"use client";

import type { FC } from "react";

import { BlogRelatedArticles } from "../BlogRelatedArticles/BlogRelatedArticles";

import type { blogArticleCarouselInputs } from "./BlogArticleCarousel.builder";

export type BlogArticleCarouselProps = BuilderComponentProps<typeof blogArticleCarouselInputs>;

export const BlogArticleCarousel: FC<BlogArticleCarouselProps> = ({ title, ctaLabel, ctaUrl, articles }) => {
  return (
    <BlogRelatedArticles
      relatedArticlesTitle={title}
      relatedArticlesCtaLabel={ctaLabel}
      relatedArticlesCtaUrl={ctaUrl}
      relatedArticles={articles}
    />
  );
};
